<template>
  <or-modal
    ref="import-csv-modal"
    title="Import Data"
    dismissOn="close-button esc"
    @close="resetForm"
  >
    <form
      class="import-csv-form"
      @submit.prevent=""
      @keydown.enter.prevent = ""
    >
      <div class="import-wrap"
        v-if="files.length === 0"
      >
        <div class="import-wrap__wrapper">
          <div :class="['drag-zone', {'drag-zone_dragged': dragging }]">
            <div class="drag-title">
              <i class="cloud material-icons">backup</i>
              <br>
              <i18n path="common.modals.import_csv_modal.dragZone.description" tag="p">
                <span class='bold' place="selectFromComputer">
                  {{ $t('common.modals.import_csv_modal.dragZone.uploadFromComputer') }}
                </span>
              </i18n>
            </div>

            <input
              class="drag-input"
              type="file"
              ref="upload"
              accept="text/csv"
              @change="onFileSelection"
              @dragenter="dragging=true"
              @dragleave="dragging=false"
              @drop="dragging=false"
            >
          </div>
        </div>
      </div>
      <div v-else class="input-form-wrap">
        <div>
          <div>
            <or-select
              has-search
              :placeholder="contextNamePlaceholder"
              :options="$props.contexts"
              :keys="{ label: 'name', value: 'name' }"
              :value="$v.contextName.$model"
              :disabled="isLoading"
              @input="changeContextName"
              :error="errors.contextName"
              :invalid="!!errors.contextName"
            />
          </div>
          <div class="file-wrap">
            <span class="file-label">{{files[0].name}}</span>
            <or-icon-button
              class="delete-btn flat"
              icon="delete"
              type="secondary"
              size="small"
              :disabled="isLoading"
              @click.native="deleteFile(files[0])"
            />
          </div>
        </div>
        <div class="actions">
          <or-button
            class="cancel-button"
            color="primary"
            type="secondary"
            buttonType="button"
            :loading="isLoading"
            @click="closeModal"
          >
            {{$t("generic.cancel")}}
          </or-button>
          <or-button
            color="primary"
            buttonType="submit"
            :loading="isLoading"
            @click="importCsv"
          >
            {{$t("generic.import")}}
          </or-button>
        </div>
      </div>
    </form>
  </or-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { importCsvValidation } from '@/mixins/import-csv-validation.mixin'

export default {
  name: 'import_csv_modal',

  mixins: [importCsvValidation],

  props: {
    contexts: Array
  },

  data () {
    return {
      files: [],
      dragging: false,
      contextName: '',
      isLoading: false
    }
  },

  computed: {
    title () {
      return this.$t('common.modals.import_csv_modal.title')
    },

    contextNamePlaceholder () {
      return this.$t('common.modals.import_csv_modal.contextName.placeholder')
    }
  },

  methods: {
    ...mapActions('knowledgebase', ['createPairsCsv']),
    onFileSelection (evt) {
      const files = evt.srcElement.files
      const importFile = files[0]
      this.files.push(importFile)
    },

    // Otherwise $v.contextName.$dirty is always true
    changeContextName (contextName) {
      if (contextName !== this.contextName) {
        this.contextName = contextName
      }
    },

    openModal () {
      this.resetForm()
      this.$refs['import-csv-modal'].open()
    },

    closeModal () {
      this.$refs['import-csv-modal'].close()
    },

    deleteFile (file) {
      this.files = this.files.filter(f => f !== file)
    },

    resetForm () {
      this.files = []
      this.dragging = false
      this.contextName = ''
      this.isLoading = false
      this.$v.$reset()
    },

    async importCsv () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.isLoading = true
      try {
        await this.createPairsCsv({ file: this.files[0], contextName: this.contextName })
        this.closeModal()
      } catch (err) {
        /** */
      }
      this.isLoading = false
    }
  }
}
</script>

<style scoped lang="scss">
  .import-csv-form {
    .input-form-wrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .actions {
        display: flex;
        justify-content: space-between;
        margin: 24px 0;
      }
    }
    .import-wrap {
      &__wrapper{
        height: 350px;
      }

      .btn-group {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
      }

      .drag-zone {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: calc(100% - 16px);
        border: 1px dashed $or-grey-medium;
        border-radius: 4px;
        margin-bottom: $sp-2;

        .cloud {
          font-size: 95px;
        }

        .drag-title {
          text-align: center;
          font-size: 14px;
          color: $or-grey-dark;
          cursor: pointer;

          .bold {
            font-weight: bold;
            color: $or-blue;
          }
        }

        .drag-input {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
        }
      }
      .drag-zone_dragged {
        border: 2px dashed $or-grey-medium;
        background-color: $or-grey-light;
      }
    }
  }
</style>
